import Myo from 'myo'
import PubSub from 'pubsub-js'

const topics = {
  connected: 'myo-connected',
  disconnected: 'myo-disconnected',
  synced: 'myo-synced',
  unsynced: 'myo-unsynced',
  batteryLevel: 'myo-battery-level',
  emg: 'myo-emg'
}

class MyoService {
  constructor() {
    Myo.on('connected', this.handleConnected);
    Myo.on('diconnected', this.handleDisconnected);
    Myo.on('arm_synced', this.handleSynced);
    Myo.on('arm_unsynced', this.handleUnsynced);
    Myo.on('battery_level', this.handleBatteryLevel);
    Myo.on('emg', this.handleEmg);
    Myo.connect();
    console.log('MyoService: initialized');
  }

  get topics() { return topics }

  handleConnected(myoEvent) {
    PubSub.publish(topics.connected, this);
    console.log('MyoService: connected');
  }

  handleDisconnected(myoEvent) {
    PubSub.publish(topics.disconnected, this);
    console.log('MyoService: disconnected');
  }

  handleSynced(myoEvent) {
    PubSub.publish(topics.synced, this);
    console.log('MyoService: synced');
  }

  handleUnsynced(myoEvent) {
    PubSub.publish(topics.unsynced, this);
    console.log('MyoService: unscynced');
  }

  handleBatteryLevel(myoEvent) {
    PubSub.publish(topics.batteryLevel, this);
    console.log('MyoService: battery level');
  }

  handleEmg(data) {
    PubSub.publish(topics.emg, { myo: this, emg: data });
  }

  getMyos(connectedOnly) {
    return connectedOnly ? 
      Myo.myos.filter((myo) => { return myo.connected; }) :
      Myo.myos;
  }
}

export let myoService = new MyoService()


/** WEBPACK FOOTER **
 ** ./src/services/MyoService.js
 **/